export default {
  title: 'components.views.forms.template-select.title'
}
